import * as angular from "angular";
import template from "./index.html";
import "./index.less";
import jsonSchemaForm from "../../../extensions/json-schema/json-schema-form";

export function controller() {
	const ctrl = this;

	ctrl.$onInit = onInit;

	function onInit() {
		const resolve = ctrl.resolve || {};

		ctrl.title = resolve.title || "Form Request";
		ctrl.schema = resolve.schema;
		const options = angular.copy(resolve.options || {});
		ctrl.options = {
			...options,
			readonly: true
		};
		ctrl.model = resolve.model || {};
	}

	ctrl.handleClose = () => {
		ctrl.modalInstance.dismiss();
	};

	ctrl.handleProcess = async() => {
		await ctrl.resolve.process();
		ctrl.modalInstance.dismiss();
	};

	ctrl.handleReject = async() => {
		const isSuccess = await ctrl.resolve.reject();

		if(isSuccess) {
			ctrl.modalInstance.dismiss();
		}
	};
}

export default angular
	.module("vesl.components.form-request-modal", [jsonSchemaForm])
	.component("formRequestModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
